module.exports = __webpack_public_path__ + "static/media/nemobius_sylvestris_006_APA.80d1f245.mp3";